export const parseRawEmail = (rawEmail) => {
    const   {
        personal = null,
        address = null
    } = /("(?<personal>(.+))"\s<)?(?<address>([^,>]+))>?/.exec(rawEmail)?.groups ?? {};

    return {
        personal,
        address
    };
};

export const parseMultipleRawEmails = async (rawEmails) => {
    //comma is not allowed symbol as we use comma to separate multiple email addresses
    const matches = rawEmails.matchAll(/("(?<personal>([^"]+))"\s<)?(?<address>([^,>]+))>?/g);
    const {apiHost, apiPath} = window.inx.mail.params.compose.contacts;
    const results = [];
    for (const match of matches) {
        let { personal = null, address = null } = match.groups;
        //MAIL-5046 creating get request url for each user email, to get and return current user name
        const cleanRecipient = address.replace(/"/g, '');
        const url = `${apiHost}${apiPath}?fields=["name","email"]&query={"sortTerms":["sort_key","asc"],"searchTerms":{"or":{"name":"${cleanRecipient}","email":"${cleanRecipient}"}}}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok: ' + response.statusText);
            }
            const data = await response.json();
            if (data.length > 0) {
                personal = data[0].name;
                address = data[0].email;
            }
        } catch (error) {
            console.error('Error fetching data for:', address, error);
        }
        results.push({
            personal,
            address
        });
    }
    return results;  // Return the array after all requests are processed
};